import React from 'react'
// import pagelogo from 'assets/finalElite/banner/logo.svg'
import pagelogo from 'assets/finalElite/banner/new-premier-elite.png'
import PremierBanner from 'organisms/premierBanner'

export default function Banner() {
  return (
    <PremierBanner
      title="Premier Elite +"
      logo={pagelogo}
      logoClasses="2xl:h-[7rem] xl:h-[5.4rem]"
      bgClasses='bg-[#371101] bg-[url("assets/finalElite/banner/elite-mobile.jpg")] md:bg-[url("assets/finalElite/banner/elite-desktop.jpg")]'
      logoAlt="Premier Elite's logo"
      bgGrad="linear-gradient(186deg, #FFF -96.64%, #F69A4D 109.37%)"
      subDesc={
        <div className="flex items-center pb-4 w-fit text-appear-anim">
          <h4 className="hidden text-lg leading-snug text-white font-regular sm:block md:text-xl lg:text-[28px] xsl:text-3xl">
            Elevating imaging precision <br className="hidden sm:block" />
            with flexible Operating <br className="hidden sm:block" /> Space and
            Deepest Angles.{' '}
          </h4>
          <h6 className="max-w-sm text-white sm:hidden">
            Elevating imaging precision with flexible Operating Space and
            Deepest Angles.{' '}
          </h6>
        </div>
      }
    />
  )
}
